import {
    curatedSearchConfig,
    rangeFiltersState,
} from "@/services/algoliaRouting.blade";

function countCuratedModelSelections(): number {
    const curatedModels = curatedSearchConfig.value.filters?.refinementList?.model;
    if (Array.isArray(curatedModels) && curatedModels.length > 0) {
        return curatedModels.length;
    }

    const landingModels =
        window.__MARKETPLACE_CONFIG__?.landingData
            ?.concentratedModelDesignations ?? [];
    if (landingModels.length > 0) {
        return landingModels.length;
    }

    return (
        window.__MARKETPLACE_CONFIG__?.initialModelsFacet?.filter(
            (item) => item.isRefined,
        ).length ?? 0
    );
}

function countCuratedMakeSelections(): number {
    const curatedMake = curatedSearchConfig.value.filters?.menu?.make;
    if (typeof curatedMake === "string" && curatedMake !== "") {
        return 1;
    }

    return (
        window.__MARKETPLACE_CONFIG__?.initialMakesFacet?.filter(
            (item) => item.isRefined,
        ).length ?? 0
    );
}

export function countCheckedInContainer(
    container: ParentNode | null,
    checkboxSelector: string,
): number {
    if (!container) return 0;

    return container.querySelectorAll<HTMLInputElement>(
        `${checkboxSelector}:checked`,
    ).length;
}

export function countMakeFacetActive(root: ParentNode = document): number {
    const container = root.querySelector("#action-bar-make");
    const checked = countCheckedInContainer(container, ".RefinementList__checkbox");
    if (checked > 0) {
        return checked;
    }

    return countCuratedMakeSelections();
}

export function countEnergyFacetActive(root: ParentNode = document): number {
    const container = root.querySelector("#action-bar-energy");
    return countCheckedInContainer(container, ".facette-button__input");
}

export function countModelFacetActive(root: ParentNode = document): number {
    const container = root.querySelector("#action-bar-model");
    const checked = countCheckedInContainer(container, ".RefinementList__checkbox");
    if (checked > 0) {
        return checked;
    }

    return countCuratedModelSelections();
}

export function countMileageFacetActive(
    rangeState = rangeFiltersState.value,
    curated = curatedSearchConfig.value,
): number {
    const range = rangeState.mileage;
    if (!range || (range.min === undefined && range.max === undefined)) {
        return 0;
    }

    if (curated.isActive && curated.filters) {
        const curatedMin = curated.filters.mileage_min as number | undefined;
        const curatedMax = curated.filters.mileage_max as number | undefined;
        if (range.min === curatedMin && range.max === curatedMax) {
            return 0;
        }
    }

    return 1;
}

export function countPriceFacetActive(
    rangeState = rangeFiltersState.value,
    curated = curatedSearchConfig.value,
): number {
    const range = rangeState.price;
    if (!range || (range.min === undefined && range.max === undefined)) {
        return 0;
    }

    if (curated.isActive && curated.filters) {
        const curatedMin = curated.filters.price_min as number | undefined;
        const curatedMax = curated.filters.price_max as number | undefined;
        if (range.min === curatedMin && range.max === curatedMax) {
            return 0;
        }
    }

    return 1;
}

export function resolveActionBarFacetActiveCount(mountId: string): number {
    switch (mountId) {
        case "action-bar-make":
            return countMakeFacetActive();
        case "action-bar-model":
            return countModelFacetActive();
        case "action-bar-energy":
            return countEnergyFacetActive();
        case "action-bar-mileage":
            return countMileageFacetActive();
        case "action-bar-price":
            return countPriceFacetActive();
        default:
            return 0;
    }
}
